
import React, { Component } from 'react';
import Base from '../../rebase';
import PropTypes from 'prop-types';

class PageBreakComponent extends Component {

  render() {
    return (
        <hr Style={this.stringForStyle(this.props.style)} />
      )
  }

  stringForStyle(style) {
    var styleString = "";
    for (var key in style) {
        styleString += key+':'+style[key]+';';
    }
    return styleString;
  }
}

export default PageBreakComponent;



// WEBPACK FOOTER //
// ./src/reusable_components/page_components/PageBreakComponent.jsx